import React from "react";
import { BECOME_FRANCHISEE_CONFIG } from "./constants";
import { FormConfigPage } from "./FormConfigPage";

export function BecomeAFranchisee() {
    return <FormConfigPage config={BECOME_FRANCHISEE_CONFIG} />;
}
